/* int-l4-related-lazy.js: moved verbatim from sections/related.liquid (pdp-html-weight lever 4, 2026-11-02). Do not edit here without the source note. */
document.addEventListener('DOMContentLoaded', function () {
    (function () {
      var el = document.querySelector('[data-int-rel-lazy]');
      if (!el || el.__intRel) return;
      el.__intRel = true;
      var src = el.getAttribute('data-src'), tries = 0, busy = false;
      function boot(root) {
        var rows = root.querySelectorAll('[data-int-related-row], .int-rel-curated');
        function fire() {
          for (var i = 0; i < rows.length; i++) {
            rows[i].dispatchEvent(new CustomEvent('theme:related-products:added', { bubbles: true }));
          }
        }
        if (!window.customElements || !customElements.whenDefined) { fire(); return; }
        customElements.whenDefined('flickity-carousel').then(function () {
          var C = customElements.get('flickity-carousel'), n = 0;
          (function wait() {
            if (!C || !C.prototype || C.prototype.__intGated || n++ > 20) { fire(); return; }
            setTimeout(wait, 0);
          })();
        })['catch'](fire);
      }
      function load() {
        if (busy) return;
        busy = true;
        fetch(src, { credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        }).then(function (html) {
          var tpl = document.createElement('template');
          tpl.innerHTML = html;
          var fresh = tpl.content.querySelector('.section-related');
          if (!fresh) { el.remove(); return; }
          el.replaceWith(fresh);
          boot(fresh);
        })['catch'](function () {
          busy = false;
          if (++tries < 2) { setTimeout(load, 2000); } else { el.remove(); }
        });
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          for (var i = 0; i < es.length; i++) {
            if (es[i].isIntersecting) { io.disconnect(); load(); return; }
          }
        }, { rootMargin: '1500px 0px' });
        io.observe(el);
      } else {
        window.addEventListener('load', load);
      }
    })();
});
